import React, {useEffect, useState, useCallback, useRef} from 'react'
import {useTranslation} from 'react-i18next'
import { GlobalCardMb16 } from './style'
import { MainTable } from '../table'

import { Card, Drawer, Modal, Space, Table, Typography, Empty } from 'antd'
import { UpOutlined } from '@ant-design/icons'
import cookie from "react-cookies";
import {abnormalPara, failurePara, offlinePara, thresholdPara} from "./tableHeader";
import {getCurrentWarning, maskFailure} from "../../request/api";
import {BlockOperation, ChartIconOperation, CopyOperation, LinkTextOperation} from "../operation";
import moment from "moment/moment";
import {BlockedTag} from "../statusTag";
import ThresholdChart from "../../pages/Alarm/components/thresholdChart";
import {Success} from "../notification";

import {DeviceStatusTag, AlarmTypeTag} from "../statusTag/index";

function CurrentAlarmTableList(props) {
    const {t, i18n} = useTranslation(); //语言包
    const [data, setData] = useState([]); //数据
    const [dataLoad, setDataLoad] = useState(false);

    // 折叠状态
    const [offlineCollapsed, setOfflineCollapsed] = useState(false);
    const [failureCollapsed, setFailureCollapsed] = useState(false);
    const [abnormalCollapsed, setAbnormalCollapsed] = useState(false);
    const [thresholdCollapsed, setThresholdCollapsed] = useState(false);

    const [offlineTableHeader, setOfflineTableHeader] = useState([])
    const [failureTableHeader, setFailureTableHeader] = useState([])
    const [abnormalTableHeader, setAbnormalTableHeader] = useState([])
    const [thresholdTaleHeader, setThresholdTableHeader] = useState([])
    const [openLine, setOpenLine] = useState(false);//选中的阈值报警 折线图
    const [thresholdSel, setThresholdSel] = useState({});//选中的阈值报警
    const defaultDate = useRef(null);

    useEffect(() => {
      props.onDrawerChange?.(openLine);
    }, [openLine]);

    useEffect(() => {
        getCurrentAlarmData();
    }, [props.psIds, props.refreshKey,i18n.language]);

    useEffect(() => {
        bindFailureTypeParam()
    }, [i18n.language])

    //获取数据
    const getCurrentAlarmData = () => {
        setDataLoad(true);
        // 获取当前报警数据
        let psIds = props.psIds !== undefined && props.psIds.startsWith(',') ? props.psIds.substring(1) : props.psIds;
        getCurrentWarning(cookie.load("userId"), psIds).then(res => {
            if (res.status === 200 && res.data !== null) {
                setDataLoad(false);
                setData(res.data);
            }
        })
        bindFailureTypeParam();
    }

    //绑定表格表头
    const bindFailureTypeParam = () => {
        //离线
        offlinePara.forEach((item, index) => {
            item.title = t(item.titlekey)
        });
        var offlineTemp = [...offlinePara];
        if (!props.allPs) {
            offlineTemp.shift();
        }
        setOfflineTableHeader(offlineTemp);

        //故障
        failurePara.forEach((item, index) => {
            item.title = t(item.titlekey)
            switch (index) {
                case 4:
                    failurePara[index].render = (_, record) => {
                        return (
                            <CopyOperation
                                carrierContent={record.failureName}
                            />
                        )
                    }
                    break;
                case 6:
                    //屏蔽操作
                    failurePara[index].render = (_, record) => {
                        const yearsDiff = moment().diff(moment(getCurrentDate()), 'year')
                        if (record.isLocalMask === 1) {
                            return (
                                <BlockedTag />
                            )
                        } else if (yearsDiff < 1) {
                            return (
                                <BlockOperation isDis={isRole(record.psId)} onConfirm={() => maskFailureHandel(record)} />
                            )
                        }
                    };
                    break;
            }
        });
        var failureTemp = [...failurePara];
        if (!props.allPs) {
            failureTemp.shift();
        }
        setFailureTableHeader(failureTemp)

        //通讯异常
        abnormalPara.forEach((item, index) => {
            item.title = t(item.titlekey)
        });
        var abnormalTemp = [...abnormalPara];
        if (!props.allPs) {
            abnormalTemp.shift();
        }
        setAbnormalTableHeader(abnormalTemp)

        //阈值报警
        thresholdPara.forEach((item, index) => {
            item.title = t(item.titlekey)
            switch (index) {
                case 2:
                    thresholdPara[index].render = (_, record) => {
                        var typeName = record.thresholdTypeName;
                        switch (i18n.language) {
                            case 'zhCN':
                                typeName = record.thresholdTypeNameCn;
                                break;
                            case 'jaJP':
                                typeName = record.thresholdTypeNameJp;
                                break;
                            case 'enUS':
                                typeName = record.thresholdTypeNameEn;
                                break;
                            default:
                                break;
                        }
                        return (
                            typeName
                        )
                    }
                    break;
                case 3:
                    thresholdPara[index].render = (_, record) => {
                        return (
                            record.math + " " + record.threshold + " " + record.unit
                        )
                    }
                    break;
                case 6:
                    //图表
                    thresholdPara[index].render = (_, record) => {
                        return (
                            <ChartIconOperation onClick={() => showDrawer(record)} />
                        )
                    }
                    break;
            }
        });
        var thresholdTemp = [...thresholdPara];
        if (!props.allPs) {
            thresholdTemp.shift();
        }
        setThresholdTableHeader(thresholdTemp)
    }

    const showDrawer = (record) => {
        setThresholdSel(record);
        if (record.recoveryTime === null) {
            defaultDate.current = moment();
        } else {
            defaultDate.current = moment(record.recoveryTime);
        }
        setOpenLine(true);

        /* === 点击图标后平滑回到页面顶部 === */
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const onClose = () => {
        setOpenLine(false);
    };

    const isRole = (psId) => {
        var flag = false;
        props.psInfoList.forEach(element => {
            if (psId === element.psId) {
                if (element.roleId !== '211112817PWYPZ2W') {
                    flag = true;
                } else {
                    flag = false;
                }
            }
        });
        return flag;
    }

    const getCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要+1
        const day = String(today.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    };

    var sucModal = useRef(null);
    const goNow = () => {
        sucModal.current?.destroy();
        if(props.onTabChange) {
            console.log('goToAlarm111')
            props.onTabChange('mask');
        }
        if(props.onPageChange) {
            console.log('goToAlarm222')
            props.onPageChange('');
        }
    }
    //屏蔽故障
    const maskFailureHandel = (record) => {
        var params = {
            userId: cookie.load("userId"),
            deviceId: record.deviceId,
            failureId: record.failure_id,
            protocol: record.protocol,
            emsg: record.emsg,
            beginTime: record.getdatetime,
            psId: record.psId
        }

        maskFailure(params).then(res => {
            if (res.status === 200) {
                sucModal.current = Modal.success({
                  wrapClassName: 'top-most-success-modal',
                  getContainer: () => document.body,
                  icon: null,
                  okButtonProps: { style: { display: 'none' } },
                  cancelButtonProps: { style: { display: 'none' } },
                });
                sucModal.current.update({
                    content: (
                        <Success
                            messageTitle={t('All.Result.Success.title-success')}
                            messageSubTitle={
                                <>
                                    <Space className={i18n.language !== 'jaJP' ? 'Show TransCenter' : 'Hide TransCenter ClearHeight'}>
                                        <Typography.Text>
                                            {t('All.Result.Success.subTitle-youCanGoto')}
                                        </Typography.Text>
                                        <LinkTextOperation
                                            onClick={goNow}
                                            linkText={t('All.Operation.DashboardSwitcher.AlarmMenu.failureBlockList')}
                                        />
                                        <Typography.Text>
                                            {t('All.Result.Success.subTitle-toUnblock')}
                                        </Typography.Text>
                                    </Space>

                                    <Space direction='vertical' className={i18n.language === 'jaJP' ? 'Show TransCenter' : 'Hide TransCenter ClearHeight'}>
                                        <LinkTextOperation
                                            onClick={goNow}
                                            linkText={t('All.Operation.DashboardSwitcher.AlarmMenu.failureBlockList')}
                                        />
                                        <Typography.Text>
                                            {t('All.Result.Success.subTitle-youCanGotoToUnblock')}
                                        </Typography.Text>
                                    </Space>
                                </>
                            }
                            messageBtn={t('All.Operation.ok')}
                            handleModel={sucModal.current}
                        />
                    ),
                    okButtonProps: { style: { display: 'none' } }, // 隐藏确认按钮
                    cancelButtonProps: { style: { display: 'none' } }, // 隐藏取消按钮
                });
                //屏蔽成功从新加载数据
                getCurrentAlarmData();
            }
        })
    }

    const hasAnyAlarm =
        (data.offlineDetail?.length   || 0) +
        (data.errorDetail?.length     || 0) +
        (data.abnormalDetail?.length  || 0) +
        (data.thresholdDetail?.length || 0) > 0;

    return (
        <>
            <GlobalCardMb16 />
            {hasAnyAlarm ? (
            <>
                {
                    data.offlineDetail && data.offlineDetail.length > 0 && (
                        <Card
                          className='mb16'
                          title={<AlarmTypeTag
                                  className="deviceStatusTagIcon"
                                  statusType="offline"
                                  statusText={t('All.Operation.Filter.AlarmType.offline')}
                                  tagType="default"
                                />
                            }
                          extra={
                            <span 
                              onClick={() => setOfflineCollapsed(!offlineCollapsed)}
                              style={{ cursor: 'pointer', fontSize: '16px' }}
                            >
                              <UpOutlined style={{ 
                                transform: offlineCollapsed ? 'rotate(180deg)' : 'rotate(0deg)',
                                transition: 'transform 0.3s ease'
                              }} />
                            </span>
                          }
                        >
                            {!offlineCollapsed && (
                                <MainTable
                                    className='bgWhiteTable'
                                    pagination={false}
                                    columns={offlineTableHeader}
                                    dataSource={data.offlineDetail}
                                    loading={dataLoad}
                                />
                            )}
                        </Card>
                    )
                }

                {
                    data.errorDetail && data.errorDetail.length > 0 && (
                        <Card 
                        className='mb16'
                        title={<AlarmTypeTag
                                  className="deviceStatusTagIcon"
                                  statusType="failure"
                                  statusText={t('All.Operation.Filter.AlarmType.failure')}
                                  tagType="default"
                                />
                        }
                        extra={
                            <span 
                              onClick={() => setFailureCollapsed(!failureCollapsed)}
                              style={{ cursor: 'pointer', fontSize: '16px' }}
                            >
                              <UpOutlined style={{ 
                                transform: failureCollapsed ? 'rotate(180deg)' : 'rotate(0deg)',
                                transition: 'transform 0.3s ease'
                              }} />
                            </span>
                          }
                        >
                            {!failureCollapsed && (
                                <MainTable
                                    className='bgWhiteTable'
                                    pagination={false}
                                    columns={failureTableHeader}
                                    dataSource={data.errorDetail}
                                    loading={dataLoad}
                                />
                            )}
                        </Card>
                    )
                }

                {
                    data.abnormalDetail && data.abnormalDetail.length > 0 && (
                        <Card
                         className='mb16'
                         title={<AlarmTypeTag
                                  className="deviceStatusTagIcon"
                                  statusType="commInterruption"
                                  statusText={t('All.Operation.Filter.AlarmType.commInterruption')}
                                  tagType="default"
                                />
                            }
                         extra={
                            <span 
                              onClick={() => setAbnormalCollapsed(!abnormalCollapsed)}
                              style={{ cursor: 'pointer', fontSize: '16px' }}
                            >
                              <UpOutlined style={{ 
                                transform: abnormalCollapsed ? 'rotate(180deg)' : 'rotate(0deg)',
                                transition: 'transform 0.3s ease'
                              }} />
                            </span>
                          }
                         >
                            {!abnormalCollapsed && (
                                <MainTable
                                    className='bgWhiteTable'
                                    pagination={false}
                                    columns={abnormalTableHeader}
                                    dataSource={data.abnormalDetail}
                                    loading={dataLoad}
                                />
                            )}
                        </Card>
                    )
                }

                {
                    data.thresholdDetail && data.thresholdDetail.length > 0 && (
                        <Card
                         className='mb16'
                         title={<AlarmTypeTag
                                  className="deviceStatusTagIcon"
                                  statusType="thresholdAlarm"
                                  statusText={t('All.Operation.Filter.AlarmType.thresholdAlarm')}
                                  tagType="default"
                                />
                            }
                         extra={
                            <span 
                              onClick={() => setThresholdCollapsed(!thresholdCollapsed)}
                              style={{ cursor: 'pointer', fontSize: '16px' }}
                            >
                              <UpOutlined style={{ 
                                transform: thresholdCollapsed ? 'rotate(180deg)' : 'rotate(0deg)',
                                transition: 'transform 0.3s ease'
                              }} />
                            </span>
                          }
                         >
                            {!thresholdCollapsed && (
                                <MainTable
                                    className='bgWhiteTable'
                                    pagination={false}
                                    columns={thresholdTaleHeader}
                                    dataSource={data.thresholdDetail}
                                    loading={dataLoad}
                                />
                            )}
                        </Card>
                    )
                }
            </>
            ) : (
              /* 无数据时显示 Empty，保持和 antd Table 空数据一样的样式 */
              <Card className="mb16">
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                />
              </Card>
            )}

            <Drawer
                className='DrawerThresholdDetail'
                placement='right'
                closable={true}
                onClose={onClose}
                open={openLine}
                getContainer={false}
                push={false}
                maskClosable={true}
                contentWrapperStyle= {{maxWidth: 800}}
            >
                <ThresholdChart thresholdSel={thresholdSel} clickDate={getCurrentDate()}/>
            </Drawer>
        </>
    );
}

export default CurrentAlarmTableList;
